<template>
	<div>
		<v-dialog v-model="dialog_product" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">
						{{$parent.Form.productDataModel.groupId ? 'Edit Item' : 'Add Item'}}
					</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <!-- <v-btn round-borders outline :disabled="disableBtn" @click="fn_checkValidations">Done</v-btn> -->
					<v-btn icon dark-opacity-color flat @click="$parent.fn_removeItem(null)" v-if="$parent.Form.productDataModel.groupId"><v-icon class="redcolor">delete</v-icon></v-btn>

				</v-toolbar>
        		
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width class="hasBigFooter">
        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 align-msg-right form-item
					        	@click="fn_openProducts">

				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.productDataModel.productName" 
					               	:hide-details="summaryArray.length ? true : false"
					               	label="Select Item" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="fn_updateProduct"
					               	ref="ref_dialogProduct_productName"
					               	v-validate="'required'" 
				               		data-vv-name="item" 
				               		:error-messages="errors.collect('fields.item')"
				               		required>
				               </v-text-field>

				               <div custom-message v-if="summaryArray.length">
				               		<span v-for="(item, index) in summaryArray" :key="index">
				               			Stock: <span :class="{'redcolor':item.qty<0}">{{ item.roundOffQty != undefined ? item.roundOffQty : roundUpto2Decimals(item.qty)}} {{item.unitName}}</span>
				               		</span>
				               </div>
				            </v-flex>

						</v-layout>

						<!-- <div class="margin-top-ten" v-if="$parent.settings.transactionTypeId != 20001 && $parent.settings.transactionTypeId != 20005">
							<v-subheader class="pr-0 white-background">Batches <v-spacer></v-spacer> <v-btn color="primary"  capitalize flat class="mr-0" @click="fn_openDialogSelectBatch">Select Batch <v-icon color="primary" class="ml-1">keyboard_arrow_down</v-icon></v-btn> </v-subheader>
							<v-list two-line nopadding>
								<v-list-tile v-for="(batch, batchIndex) in $parent.Form.productDataModel.batches" :key="batchIndex">
									<v-list-tile-content>
										<v-list-tile-sub-title>Batch Number: {{batch.batchNumber}}</v-list-tile-sub-title>
										<v-list-tile-sub-title>Qty: {{batch.productQty}} {{ fn_getLabel($parent.Form.productDataModel.productVariants[0]) }}</v-list-tile-sub-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-btn flat icon @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
									</v-list-tile-action>
								</v-list-tile>
							</v-list>
						</div> -->

						<v-layout margin-top-ten row wrap padding-top-ten white-background>
							<!-- <v-flex xs6 sm6 md6 pr-2 pl-3 v-if="$root.TransactionSettings.mrpWiseStock">
					           	<v-text-field 
									:disabled="disableBtn"
					           		v-model.number="$parent.Form.productDataModel.mrp"
					           		label="MRP" 
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:2'" 
				               		data-vv-name="mrp" 
				               		:error-messages="errors.collect('fields.mrp')">
					           	</v-text-field>
					        </v-flex> -->

							<v-layout row wrap v-for="(item, vIndex) in $parent.Form.productDataModel.productVariants" :key="vIndex">
					        	 <v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<!-- <v-text-field 
									   	:disabled="disableBtn"
						           		v-model.number="item.qty"
						           		:hint="item.billQty != undefined ? 'Bill Qty: ' + item.billQty : ''"
						           		persistent-hint
						           		@input="fn_checkInput(item)"
						           		label="Quantity" 
						           		placeholder="1"
						           		type="number"
						           		v-validate="'numeric|max:8'" 
					               		:data-vv-name="item.unitName+vIndex" 
					               		data-vv-as="quantity"
					               		:error-messages="errors.collect('fields.'+item.unitName+vIndex)">
						           	</v-text-field> -->
									<!-- :hint="item.billQty != undefined ? 'Bill Qty: ' + fn_getBillQty(item) : ''" -->
									<v-text-field 
									   	:disabled="disableBtn || ($parent.Form.productDataModel.batches && $parent.Form.productDataModel.batches.length) ? true : false"
						           		v-model="item.qty"
						           		:hint="fn_getBillQty(item)"
						           		persistent-hint
										@input="fn_changeProductQty(item)"
						           		label="Quantity" 
						           		placeholder="1"
						           		type="number">
						           	</v-text-field>
						        </v-flex>
								<!-- @input="$root.fn_boundDecimalLength(item, fn_checkInput, 'qty')" -->

								<!-- <v-flex xs6 sm6 md6 pr-3 pl-2>
									<v-text-field 
										:disabled="true"
										:value="fn_getLabel(item)"
										label="Unit"
										placeholder=" ">
									</v-text-field>
								</v-flex> -->

								<v-flex xs6 sm6 md6 pr-3 pl-2>
									<v-text-field 
										v-if="!item.secondaryUnitId"
										:disabled="true"
										:value="fn_getLabel(item)"
										label="Unit"
										placeholder=" ">
									</v-text-field>
									<v-select
										v-else
										:items="[{itemId:item.unitId, itemName:item.unitName}, {itemId:item.secondaryUnitId, itemName:item.secondaryUnitName}]"
										label="Unit"
										:disabled="$parent.Form.selectedBatchType == 2 && $parent.Form.productDataModel.batches && $parent.Form.productDataModel.batches.length"
										item-text="itemName"
										item-value="itemId"
										v-model="item.selectedUnit"
										:hide-details="true"
										return-object
										@change="fn_unitChange($event, item)"
										ref="ref_unitSelection"
									></v-select>
									<div class="pb-3 pt-1 right-align" v-if="item.secondaryUnitId">{{ item.packQuantity }} {{ item.unitName }} = {{ item.secondaryUnitPackQuantity }} {{ item.secondaryUnitName }}</div>
									<!-- do not remove using this to display selected unit in batch items -->
									<div style="display: none;">{{ item }}</div>
								</v-flex>

								<!-- <div redcolor class="pl-3 pb-2" full-width v-if="productData.groupTypeId == 101 && summaryArray && summaryArray.length && (!summaryArray[0].qty || summaryArray[0].qty < item.qty)">
									<v-icon style="color: red !important;" font16 class="mr-1">info_outline</v-icon>
									<span v-if="summaryArray[0].qty <= 0">Item is out of stock</span>
									<span v-else>Only {{ summaryArray[0].qty }} {{ fn_getLabel(item) }} {{ summaryArray[0].qty > 1 ? 'are' : 'is' }} in stock.</span>
								</div> -->
					        </v-layout>

							<v-flex xs6 sm6 md6 pr-2 pl-3 v-if="$root.TransactionSettings.mrpWiseStock">
					           	<v-text-field 
									:disabled="disableBtn"
					           		v-model.number="$parent.Form.productDataModel.mrp"
					           		label="MRP" 
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:2'" 
				               		data-vv-name="mrp" 
				               		:error-messages="errors.collect('fields.mrp')">
					           	</v-text-field>
					        </v-flex>

							<v-flex xs6 sm6 md6 pr-3 pl-2 :class="[!$root.TransactionSettings.mrpWiseStock ? 'xs12 sm12 md12 pr-3 pl-3' : 'xs6 sm6 md6 pr-3 pl-2']" v-if="$parent.Form.productDataModel && $parent.Form.productDataModel.productVariants && $parent.Form.productDataModel.productVariants.length">
					           	<v-text-field 
								   	:disabled="disableBtn"
					           		v-model.number="$parent.Form.productDataModel.rate"
					           		:label="$parent.Form.productDataModel.productVariants[0].secondaryUnitId ? 'Rate (Per ' + $parent.Form.productDataModel.productVariants[0].selectedUnit.itemName + ')' : 'Rate (Per ' + $parent.Form.productDataModel.productVariants[0].unitName + ')'"
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:4'" 
				               		data-vv-name="rate" 
				               		:error-messages="errors.collect('fields.rate')">
					           	</v-text-field>
					        </v-flex>

						</v-layout>

						<div full-width v-if="$parent.Form.dynamicItemSection && $parent.Form.dynamicItemSection.length">
							<component-dynamic-fields ref="ref_componentDynamicFields" :openAccountLedgers="$parent.fn_openAccountLedgers" :openListItems="$parent.fn_openListItems" :openDatePicker="$parent.fn_openDatePicker" :dynamicFields="$parent.Form.productDataModel.customFields"></component-dynamic-fields>
						</div>

						<div class="pt-2 pb-2 grey-back full-width" v-if="$parent.toolbarTitle != 'Debit Note' && $parent.settings.transactionTypeId != 20001">

							<template v-if="hasSeries && !hasOnlySeries && $root.TransactionSettings.enableBatch">
								<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="$parent.Form.selectedBatchType" row @change="fn_changeBatchType($event)">
									<v-radio label="Batch" :value="1"></v-radio>
									<v-radio label="Series" :value="2"></v-radio>
								</v-radio-group>
								<v-divider></v-divider>
							</template>

							<!-- <v-subheader class="pr-0 white-background">Batches <v-spacer></v-spacer> 
								<v-btn color="primary"  capitalize flat class="mr-0" @click="fn_openDialogSelectBatch">Select Batch <v-icon color="primary" class="ml-1">keyboard_arrow_down</v-icon></v-btn> 
								<v-btn color="primary"  capitalize flat class="mr-0" @click="fn_newBatch">New Batch <v-icon color="primary" class="ml-1">add</v-icon></v-btn>
							</v-subheader> -->
							<v-subheader class="white-background" v-if="$parent.toolbarTitle != 'Debit Note' && ($root.TransactionSettings.enableBatch || (!$parent.Form.isNew && $parent.Form.productDataModel.batches && $parent.Form.productDataModel.batches.length))">
								<template v-if="$parent.Form.selectedBatchType == 2"><span v-for="(field, index) in seriesFields" :key="field.title">{{ field.title }}<span v-if="seriesFields.length - 1 != index">/</span></span></template>
								<template v-else>Batches</template>
								<v-spacer></v-spacer> 
								<!-- <v-btn color="primary"  capitalize flat class="mr-0" @click="fn_openDialogSelectBatch">Select <v-icon color="primary" class="ml-1">keyboard_arrow_down</v-icon></v-btn> -->

								<template v-if="$root.TransactionSettings.enableBatch">
									<v-btn v-if="$parent.Form.productDataModel.baseTransactionListId == 20003 && $parent.settings.transactionTypeId == 20004" small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogReturnForm('ref_dialogReturnForm')">
										<v-icon class="mr-1" font16 color="primary">edit</v-icon> Change Batch Quantity
									</v-btn>

									<v-btn v-else small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="fn_openDialogSelectBatch">
										<v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
									</v-btn>
								</template>

							</v-subheader>

							<v-card flat v-for="(batch, batchIndex) in $parent.Form.productDataModel.batches" :key="batchIndex" v-if="fn_showHideBatches(batch)">
								<v-divider></v-divider>
								<v-card-text class="pb-2">
									<div style="float: left;margin-right: 12px;" v-if="($parent.Form.productDataModel.baseTransactionListId != 20003 && $parent.settings.transactionTypeId == 20004) || $parent.settings.transactionTypeId == 20002 || $parent.settings.transactionTypeId == 20003">
										<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
									</div>
									<v-layout class="batch_layout" row wrap>
										<!-- <v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="field.id != 'opening' && $parent.fn_fieldVisibilty(field, $parent.Form.selectedBatchType)">
											<div light-opacity-color>{{ field.title }}</div>
											<div v-if="field.type == 'date'">{{ batch[field.id] | moment('DD-MMM-YYYY') }}</div>
                                    		<div v-else>{{ batch[field.id] }}</div>
										</v-flex> -->
											<!-- <v-flex xs2 sm2 md2 mb-2 v-if="($parent.Form.productDataModel.baseTransactionListId != 20003 && $parent.settings.transactionTypeId == 20004) || $parent.settings.transactionTypeId == 20002 || $parent.settings.transactionTypeId == 20003">
												<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
											</v-flex> -->
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
												<div light-opacity-color>Batch No.</div>
												<div>{{ batch.batchNumber }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
												<div light-opacity-color>Size</div>
												<div>{{ batch.batchSize }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
												<div light-opacity-color>MRP</div>
												<div>{{ batch.batchMRP }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
												<div light-opacity-color>Mfg. Date</div>
												<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
												<div light-opacity-color>Exp. Date</div>
												<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
											</v-flex>
											<!-- <v-flex xs4 sm4 md4 mb-2>
												<div light-opacity-color>Opening</div>
												<div>{{ batch.opening ? batch.opening : 0  }}</div>
											</v-flex> -->
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
												<div light-opacity-color>Purchase Rate</div>
												<div>{{ batch.purchaseRate }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
												<div light-opacity-color>Serial Number</div>
												<div>{{ batch.field1 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
												<div light-opacity-color>IMEI Number</div>
												<div>{{ batch.field2 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
												<div light-opacity-color>Part Number</div>
												<div>{{ batch.field3 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
												<div light-opacity-color>Model Number</div>
												<div>{{ batch.field4 }}</div>
											</v-flex>
											<!-- <v-flex xs4 sm4 md4 mb-2>
												<div light-opacity-color>Quantity</div>
												<div>{{ batch.qty }}</div>
											</v-flex> -->
									</v-layout>

									<v-layout row wrap :style="{'paddingLeft':$parent.Form.productDataModel.baseTransactionListId == 20003 && $parent.settings.transactionTypeId == 20004 ? '0px' : '40px'}" v-if="$parent.Form.selectedBatchType == 1">
										<!-- <v-flex xs4 sm4 md4 pr-2 :class="{'error_background':batch.currentStock<0}">
											<v-text-field
												readonly
												:error="batch.currentStock<0"
												label="Stock"
												:value="batch.currentStock ? batch.currentStock : 0"
												placeholder=" "
											></v-text-field>
										</v-flex> -->

										<v-flex xs6 sm6 md6>
											<v-text-field
												label="Quantity"
												:disabled="($parent.Form.productDataModel.baseTransactionListId == 20003 && $parent.settings.transactionTypeId == 20004) || !$root.TransactionSettings.enableBatch"
												v-model.number="batch.productQty"
												:hint="batch.billQty != undefined ? 'Bill Qty: ' + batch.billQty : ''"
												persistent-hint
												@input="fn_changeBatchQty(batch)"
												type="number"
												placeholder=" "
												v-validate="'min_value:0'" 
												data-vv-name="qty" 
												:hide-details="!errors.has('fields.qty') || !batch.billQty"
												:error-messages="errors.collect('fields.qty')"
											></v-text-field>
										</v-flex>

										<v-flex xs6 sm6 md6 pl-3>
											<v-text-field
												label="Unit"
												:disabled="true"
												:hide-details="!errors.has('fields.qty')"
												:value="$parent.Form.productDataModel.productVariants[0].selectedUnit ? $parent.Form.productDataModel.productVariants[0].selectedUnit.itemName : $parent.Form.productDataModel.productVariants[0].unitName"
											></v-text-field>
										</v-flex>

										<v-flex xs12 sm12 md12 pt-1 pb-1 pr-2 right-align :class="{'error_background redcolor':batch.currentStock<0}">
											Current Stock: {{ batch.currentStock ? roundUpto2Decimals(batch.currentStock) : 0 }} {{ $parent.Form.productDataModel.productVariants[0].primaryUnitName }}
										</v-flex>

										<v-flex xs12 sm12 md12 redcolor pb-2 pt-2 v-if="batch.expDate && $parent.fn_checkDate(batch)">
											<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ $parent.fn_getDate(batch) }}
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
							
							<!-- <v-list two-line nopadding v-if="$parent.Form.productData.items.length">
								<v-list-tile v-for="(batch, batchIndex) in $parent.Form.productData.items[0].batches" :key="batchIndex">
									<v-list-tile-content>
										<v-list-tile-sub-title>Batch Number: {{batch.batchNumber}}</v-list-tile-sub-title>
										<v-list-tile-sub-title>Qty: {{batch.productQty}} {{ fn_getLabel($parent.Form.productData.items[0].productVariants[0]) }}</v-list-tile-sub-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-btn flat icon @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
									</v-list-tile-action>
								</v-list-tile>
							</v-list> -->
						</div>

				        <div white-background v-if="$parent.Form.productDataModel.addOnsItems.length">
				        	<!-- <v-subheader>Discounts/Taxes/Other Charges</v-subheader> -->
				        	<!-- <v-divider></v-divider> -->
					        <v-layout row wrap padding-top-ten v-for="(item, index) in $parent.Form.productDataModel.addOnsItems" :key="index" v-if="!item.isGst">

					        	<v-layout row wrap v-if="item.mode==0">
					        		<v-flex xs6 sm6 md6 form-item pr-2 pl-3>
							           	<v-text-field 
										   	:disabled="disableBtn"
											suffix="%"
							           		v-model.number="item.percentage"
							           		@input="fn_checkPercentage(item)"
							           		:label="item.name"
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		:data-vv-name="'percent'+index" 
						               		:data-vv-as="item.name"
						               		:error-messages="errors.collect('fields.percent'+index)">
							           	</v-text-field>

							        </v-flex>

							        <v-flex xs6 sm6 md6 form-item pr-3 pl-2>
							           	<v-text-field 
										   	:disabled="disableBtn"
							           		v-model.number="item.value"
							           		@input="item.percentage = null"
							           		prefix="₹"
							           		:suffix="item.nature ? '(-)' : ''"
							           		label=""
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		:data-vv-name="'value'+index" 
						               		:data-vv-as="item.name"
						               		:error-messages="errors.collect('fields.value'+index)">
							           	</v-text-field>

							        </v-flex>
					        	</v-layout>

					        	<v-flex xs12 sm12 md12 form-item v-else>
						           	<v-text-field 
									   	:disabled="disableBtn"
						           		v-model.number="item.value"
						           		:label="item.name+' (₹)'"
							           	:suffix="item.nature ? '(-)' : ''"
						           		placeholder=" "
						           		type="number"
						           		v-validate="'min_value:0|decimal:2'" 
					               		:data-vv-name="'value'+index" 
					               		:data-vv-as="item.name"
					               		:error-messages="errors.collect('fields.value'+index)">
						           	</v-text-field>

						        </v-flex>

					        </v-layout>
				        </div>

				        <!-- <v-layout row wrap margin-top-ten padding-top-ten white-background v-if="$parent.Form.taxMode && $parent.Form.productDataModel.taxValue!=null"> -->
				        <v-layout row wrap padding-top-ten white-background v-if="$parent.Form.taxMode">

				        	<v-layout row wrap>
				        		<v-flex xs12 sm12 md12 form-item @click="openTaxCategories">
				        			<v-text-field  
						               	readonly
						               	v-model="$parent.Form.productDataModel.taxCategoryName" 
						               	label="Tax Category" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down">
					               </v-text-field>
				        		</v-flex>
				        	</v-layout>

				        	<v-layout row wrap>

				        		<v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<v-text-field 
						           		:disabled="true"
										suffix="%"
						           		v-model="$parent.Form.productDataModel.taxValue"
						           		:label="$parent.Form.isRcmApplicable ? 'GST (RCM)' : 'GST'" 
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>

						        <v-flex xs6 sm6 md6 pr-3 pl-2>
						           	<v-text-field 
						           		:disabled="true"
						           		v-model="$parent.Form.productDataModel.taxAmount"
						           		label="" 
						           		prefix="₹"
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>   

				        	</v-layout>

				        	<!-- v-if="$parent.Form.productDataModel.cessValue" -->
				        	<v-layout row wrap v-if="$parent.Form.productDataModel.isCessApplicable">

								<template v-if="$parent.Form.productDataModel.cessValue != undefined">

									<v-flex xs6 sm6 md6 pr-2 pl-3>
										<v-text-field 
											:disabled="true"
											v-model="$parent.Form.productDataModel.cessValue"
											:label="$parent.Form.isRcmApplicable ? 'Cess (RCM)' : 'Cess'" 
											suffix="%"  
											placeholder=" ">
										</v-text-field>
									</v-flex>

									<v-flex xs6 sm6 md6 pr-3 pl-2>
										<v-text-field 
											:disabled="true"
											@input="$parent.Form.productDataModel.cessValue = null"
											type="number"
											v-model.number="$parent.Form.productDataModel.cessAmount"
											label="" 
											prefix="₹"
											placeholder=" "
											v-validate="'min_value:0|decimal:2'" 
											data-vv-name="cessAmount" 
											data-vv-as="cess amount" 
											:error-messages="errors.collect('fields.cessAmount')">
										</v-text-field>
									</v-flex>   

								</template>

								<template v-if="$parent.Form.productDataModel.cessValueOnQuantity != undefined">
									<v-flex xs6 sm6 md6 pr-2 pl-3>
										<v-text-field 
											v-model="$parent.Form.productDataModel.cessValueOnQuantity"
											label="Cess (Per Qty)"
											prefix="₹" 
											placeholder=" ">
										</v-text-field>
									</v-flex>

									<v-flex xs6 sm6 md6 pr-3 pl-2>
										<v-text-field 
											:disabled="true"
											@input="$parent.Form.productDataModel.cessAmountOnQty = null"
											type="number"
											v-model.number="$parent.Form.productDataModel.cessAmountOnQty"
											label="" 
											prefix="₹"
											placeholder=" "
											v-validate="'min_value:0|decimal:2'" 
											data-vv-name="cessQtyAmount" 
											data-vv-as="cess amount" 
											:error-messages="errors.collect('fields.cessQtyAmount')">
										</v-text-field>
									</v-flex>
								</template>
				        		

				        	</v-layout>

					        <v-flex xs12 sm12 md12 form-item v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && $root.CurrentBusiness.HSNApplicable">
					           	<v-text-field 
								   :disabled="disableBtn"
					           		v-model="$parent.Form.productDataModel.hsnCode"
					           		label="HSN" 
					           		placeholder=" "
					           		v-validate="'verify_hsn'" 
				               		data-vv-name="hsn" 
				               		:error-messages="errors.collect('fields.hsn')">
					           	</v-text-field>
					        </v-flex>

				        </v-layout>

						<v-layout row wrap white-background>
							<v-flex xs12 sm12 md12 form-item v-if="$root.TransactionSettings.showPacking && $parent.toolbarTitle != 'Debit Note'">
								<v-text-field 
									:disabled="disableBtn"
									v-model="$parent.Form.productDataModel.packing"
									:label="$root.TransactionSettings.packingLabel ? $root.TransactionSettings.packingLabel : 'Pack Qty'" 
									placeholder=" ">
								</v-text-field>
							</v-flex>
						</v-layout>

						<v-list white-background full-width nopadding v-if="netAmount">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>Item Total</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									&#8377; {{$root.numberToLocale(netAmount)}}
									<!-- <span v-if="$parent.Form.isRcmApplicable">
										&#8377; {{$root.numberToLocale(netAmount - $parent.Form.productDataModel.taxAmount - $parent.Form.productDataModel.cessAmount)}}
									</span>
									<span v-else>
										&#8377; {{$root.numberToLocale(netAmount)}}
									</span> -->
								</v-list-tile-action>
								<!-- <v-list-tile-action>&#8377; {{$root.numberToLocale(netAmount)}}</v-list-tile-action> -->
							</v-list-tile>
						</v-list>

						<v-layout white-background wrap margin-top-ten pb-3 pt-3>
							<v-flex xs12 sm12 md12 form-item>
								<v-textarea
									:disabled="disableBtn"
									v-validate="'max:255'"
									data-vv-name="notes" 
									:error-messages="errors.collect('fields.notes')"
									v-model="$parent.Form.productDataModel.description"
									label="Notes"
									placeholder=" "
									rows="2"
									:counter="255">
								</v-textarea>
							</v-flex>
						</v-layout>
						
        	  		</v-form>
        	  		
        	  	</v-card-text>
        	  	<!-- <v-divider></v-divider>
		        <v-card-actions :class="{'error--text':netAmount<0}">
		          Amount<v-spacer></v-spacer>&#8377; {{netAmount ? $root.numberToLocale(netAmount) : netAmount}}
		        </v-card-actions> -->

				<div white-background full-width nopadding style="position:fixed;bottom:0;">
					<template v-if="$parent.Form.productDataModel.batches && $parent.Form.productDataModel.batches.length">
						<v-layout row wrap>
							<v-flex xs6 sm6 md6 pl-3 pt-1 pb-1 white-background>
								Total Qty:
							</v-flex>
							<v-flex xs6 sm6 md6 pr-3 pt-1 pb-1 right-align white-background>
								{{ $parent.Form.productDataModel.productVariants[0].qty }} {{ $parent.Form.productDataModel.productVariants[0].selectedUnit ? $parent.Form.productDataModel.productVariants[0].selectedUnit.itemName : $parent.Form.productDataModel.productVariants[0].unitName }}
							</v-flex>
						</v-layout>
					</template>
					<v-layout row wrap style="background:#ddd;">
						<v-flex xs6 sm6 md6>
							<v-btn style="height:48px !important" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkFields(true)">Done &amp; New</v-btn>
						</v-flex>
						<v-flex xs6 sm6 md6>
							<v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkFields(false)">Done</v-btn>
						</v-flex>
					</v-layout>
				</div>

	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
// const menuItem = require('../../../../../config.js').configs.menuItem;
const transactionTypes = require('../../../../../config.js').configs.transactionTypes;
import componentDynamicFields from '../../../../dialogs/component_dynamic_fields'

export default{
	props:['openProducts', 'openTaxCategories', 'saveItem'],
	components:{
		'component-dynamic-fields':componentDynamicFields
	},
	data(){	
		return{
			dialog_product: false,
			summaryArray:[],
			disableBtn:false,
			hasOnlySeries:true,
			hasSeries:false,
			seriesFields:[],
			dialogJustOpen:true
			// tempRate:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.$validator.reset();
			this.summaryArray = [];
			this.seriesFields = [];
			this.dialog_product = true;

			if(this.$root.TransactionSettings.enableBatch && this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
						this.seriesFields.push(field);
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}

				if(!this.$parent.Form.selectedBatchType){
					this.$parent.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
				}
			}

			// setTimeout(() => {
			// 	if(localStorage.getItem('batch_data')){
			// 		if(!this.$parent.Form.productDataModel.batches || !this.$parent.Form.productDataModel.batches.length){
			// 			this.$parent.Form.productDataModel.batches = [];
			// 		}
			// 		let bArray = JSON.parse(localStorage.getItem('batch_data'));
			// 		for(let i=0; i<bArray.length; i++){
			// 			bArray[i].productQty = null;
			// 			this.$parent.Form.batches.push(bArray[i]);
			// 			this.$parent.Form.productDataModel.batches.push(bArray[i]);
			// 			this.$forceUpdate();
			// 			this.$parent.fn_saveDraft(this.$parent.Form.partyName);
			// 		}

			// 		localStorage.removeItem('batch_data');
			// 	}
			// }, 1000);
			this.dialogJustOpen = true;
			setTimeout(() => {
				this.dialogJustOpen = false;
			}, 500);
		},
		closeDialogWeb: function () {
			this.dialog_product = false;
		},
		fn_getBillQty(item){
			if(item.billQty != undefined){
				let unitName = item.selectedUnit ? item.selectedUnit.itemName : item.unitName;
				return 'Bill Qty: ' + item.billQty + ' ' + unitName;
			}
			else{
				return '';
			}
			// if(variant.primaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.primaryUnitId){
			// 	return this.roundUpto2Decimals((variant.billQty * variant.secondaryUnitPackQuantity) / variant.packQuantity);
			// }
			// else if(variant.secondaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.secondaryUnitId){
			// 	return this.roundUpto2Decimals(variant.billQty / variant.secondaryUnitPackQuantity);
			// }
			// else{
			// 	return variant.billQty;
			// }
		},
		fn_checkInput: function (variant, isReturn) {
			let isQtyValid = true;
			if(variant.secondaryUnitId){
				if(variant.primaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.primaryUnitId){
					if(variant.billQty != undefined && variant.qty > ((variant.billQty * variant.secondaryUnitPackQuantity) / variant.packQuantity)){
						this.showToast("Quantity should be less then or equal to bill quantity");
						isQtyValid = false;
					}
				}
				else if(variant.secondaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.secondaryUnitId){
					if(variant.billQty != undefined && variant.qty > (variant.billQty / variant.secondaryUnitPackQuantity)){
						this.showToast("Quantity should be less then or equal to bill quantity");
						isQtyValid = false;
					}
				}
				else{
					if(variant.billQty != undefined && variant.qty > variant.billQty){
						this.showToast("Quantity should be less then or equal to bill quantity");
						isQtyValid = false;
					}
				}
			}
			else{
				if(variant.billQty != undefined && variant.qty > variant.billQty){
					this.showToast("Quantity should be less then or equal to bill quantity");
					isQtyValid = false;
				}
			}

			if(isReturn){
				return isQtyValid;
			}
			// if(variant.billQty != undefined && variant.qty > variant.billQty){
			// 	// this.$parent.snackbar_msg = 'Return quantity should be less then or equal to bill quantity';
			// 	// this.$parent.snackbar = true;
			// 	this.showToast("Quantity should be less then or equal to bill quantity");
			// }
		},
		fn_openProducts: function () {
			this.openProducts('android', 'Products', 'ref_dialogProduct_productName', this.$parent.Form.productDataModel.productId, this.$parent.Form.productDataModel.productName);
		},
		fn_updateProduct: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				this.$parent.Form.productDataModel.productId = selectedValueId;
	        	this.$parent.Form.productDataModel.productName = selectedValueName;
	        	this.$forceUpdate();
	        	this.errors.remove('fields.item');
	        	// this.fn_getItem(selectedValueId)
	        	this.fn_getProductData(false, selectedValueId);

				if(this.$parent.Form.productDataModel && this.$parent.Form.productDataModel.productVariants && this.$parent.Form.productDataModel.productVariants.length && !this.$parent.Form.productDataModel.productVariants[0].secondaryUnitId){
					this.$parent.Form.productDataModel.productVariants[0].selectedUnit = null;
				}
	        	// this.fn_getSummary(selectedValueId);
			}
			else{
				this.$parent.Form.productDataModel.productId = null;
	        	this.$parent.Form.productDataModel.productName = null;
			}
		},
		// fn_getItem: function(itemId){
		// 	let itemExist = false;

		// 	let itemIndex = this.$parent.Form.items.findIndex(item=>{
		// 		return item.productId == itemId
		// 	})

		// 	if(itemIndex!=-1){
		// 		let self =this;
		// 		setTimeout(function () {
		// 			self.editItem(self.$parent.Form.items[itemIndex]);
		// 		},300)
		// 	}
		// 	else{
		// 		this.fn_getProductData(false, itemId);
		// 	}
		// },
		fn_getProductData: function (refreshUnits, itemId, baseTransactionListId) {
			let self = this;
			this.getData('Product', itemId, 
				{
					onSuccess: function(response){
			          console.log(response);
			          let productData = JSON.parse(response);
			        //   self.fn_getSummary(productData.productId);
							if(self.$parent.Form.godownId){
								self.fn_getSummaryGodownWise(productData.productId);
							}
							else{
								self.fn_getSummary(productData.productId);
							}

			          if(refreshUnits){
			          	self.fn_refreshUnits(productData.productVariants, baseTransactionListId);

						//   if(productData.productVariants[0].secondaryUnitId){
						// 		self.$parent.Form.productDataModel.productVariants[0].unitId = productData.productVariants[0].unitId;
						// 		self.$parent.Form.productDataModel.productVariants[0].unitName = productData.productVariants[0].unitName;

						// 		self.$parent.Form.productDataModel.productVariants[0].secondaryUnitId = productData.productVariants[0].secondaryUnitId;
						// 		self.$parent.Form.productDataModel.productVariants[0].secondaryUnitName = productData.productVariants[0].secondaryUnitName;

						// 		self.$parent.Form.productDataModel.productVariants[0].secondaryUnitPackQuantity = productData.productVariants[0].secondaryUnitPackQuantity;
						// 	}

						// if(!self.$parent.Form.productDataModel.productVariants[0].unitId){
						// 	self.$parent.Form.productDataModel.productVariants[0].unitId = productData.productVariants[0].unitId;
						// 	self.$parent.Form.productDataModel.productVariants[0].unitName = productData.productVariants[0].unitName;
						// 	self.$parent.Form.productDataModel.productVariants[0].packQuantity = productData.productVariants[0].packQuantity;
						// }
						// else{
						// 	if(self.$parent.Form.productDataModel.productVariants[0].primaryUnitId && self.$parent.Form.productDataModel.productVariants[0].primaryUnitName){
						// 		self.$parent.Form.productDataModel.productVariants[0].unitId = self.$parent.Form.productDataModel.productVariants[0].unitId;
						// 		self.$parent.Form.productDataModel.productVariants[0].unitName = self.$parent.Form.productDataModel.productVariants[0].unitName;
						// 		self.$parent.Form.productDataModel.productVariants[0].packQuantity = self.$parent.Form.productDataModel.productVariants[0].packQuantity;
						// 	}
							
						// }

						if(!self.$parent.Form.productDataModel.productVariants[0].secondaryUnitId){
							self.$parent.Form.productDataModel.productVariants[0].secondaryUnitId = productData.productVariants[0].secondaryUnitId;
							self.$parent.Form.productDataModel.productVariants[0].secondaryUnitName = productData.productVariants[0].secondaryUnitName;
							self.$parent.Form.productDataModel.productVariants[0].secondaryUnitPackQuantity = productData.productVariants[0].secondaryUnitPackQuantity;

							if(!self.$parent.Form.productDataModel.productVariants[0].packQuantity || (self.$parent.Form.productDataModel.productVariants[0].packQuantity != productData.productVariants[0].packQuantity)){
								self.$parent.Form.productDataModel.productVariants[0].packQuantity = productData.productVariants[0].packQuantity;
							}
						}
			          }
			          else{
			          	self.fn_bindData(productData);
			          }
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_refreshUnits: function (variants, baseTransactionListId) {
			let productVariants = this.$parent.Form.productDataModel.productVariants;
      		if(variants.length != productVariants.length){

				for(var j in variants){
				   	var shared = false;

				   	for (var k in productVariants){
				   		if (productVariants[k].productVariantId == variants[j].productVariantId) {
				           shared = true;
				           break;
				       }
				   	}
				       
				   	if(!shared){
				   		let variantObj = {};

			          	variantObj.unitName = variants[j].unitName;
			          	variantObj.unitId = variants[j].unitId;
			          	variantObj.primaryUnitId = variants[j].variantBaseUnitId;
			          	variantObj.packQuantity = variants[j].packQuantity;
			          	variantObj.productId = variants[j].productId;
			          	variantObj.productVariantId = variants[j].productVariantId;

			          	variantObj.qty = null;

			          	//adding bill qty 0 while ading variant in case of edit
			          	if(this.$parent.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id && baseTransactionListId == transactionTypes.purchaseInvoice.id){
			          		variantObj.billQty = 0;
			          	}

			          	productVariants.splice(j, 0, variantObj);
				   	} 
				}

			}
		},
		fn_bindData: function (productData) {
			this.$parent.Form.productDataModel.productVariants = JSON.parse(JSON.stringify(productData.productVariants));

			self = this;
			this.$parent.Form.productDataModel.productVariants.forEach( function(item) {
				item.primaryUnitId = item.variantBaseUnitId;
				item.primaryUnitName = item.unitName;

				self.$set(item, 'qty', 1);
				
				//setting pack quantity 1 in case of null or base variant
				!item.packQuantity ? item.packQuantity = 1 : '';

				if(item.secondaryUnitId && !item.selectedUnit){
					item.selectedUnit = {};
					item.selectedUnit.itemId = item.unitId;
					item.selectedUnit.itemName = item.unitName;
				}
			});

			this.$parent.Form.productDataModel.mrp = productData.mrp;
			this.$parent.Form.productDataModel.rate = productData.purchaseRate;

			
			// this.$parent.Form.productDataModel.taxValue = productData.taxValue;
			// this.$parent.Form.productDataModel.cessValue = productData.cessValue;
			this.$parent.Form.productDataModel.hsnCode = productData.hsnCode;

			this.$parent.Form.productDataModel.packing = productData.packing;

			// if(productData && productData.purchaseTaxCategoryId){
			// 	this.$parent.Form.productDataModel.taxCategoryId = productData.purchaseTaxCategoryId;
			// 	this.$parent.Form.productDataModel.taxCategoryName = productData.purchaseTaxCategoryName;
			// 	this.$parent.Form.productDataModel.taxValue = productData.purchaseTaxValue;
			// 	this.$parent.Form.productDataModel.cessValue = productData.purchaseCessValue;
			// 	this.$parent.Form.productDataModel.cessValueOnQuantity = productData.cessValueOnQuantity ? productData.cessValueOnQuantity : null;
			// 	this.$parent.Form.productDataModel.isCessApplicable = productData.purchaseIsCessApplicable;

			// 	//saving default tax value for draft
			// 	this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.purchaseTaxCategoryId;
			// 	this.$parent.Form.productDataModel.defaultTaxValue = productData.purchaseTaxValue;
			// 	this.$parent.Form.productDataModel.defaultCessValue = productData.purchaseCessValue;
			// 	this.$parent.fn_checkTaxCategory();
			// }
			// else{
				if(this.$parent.fn_isNewTaxForm()){
					this.$parent.Form.productDataModel.taxCategoryId = productData.newTaxCategoryId;
					this.$parent.Form.productDataModel.taxCategoryName = productData.newTaxCategoryName;
					this.$parent.Form.productDataModel.taxValue = productData.newTaxValue;
					this.$parent.Form.productDataModel.cessValue = productData.newCessValue;
					this.$parent.Form.productDataModel.cessValueOnQuantity = productData.newCessValueOnQuantity ? productData.newCessValueOnQuantity : null;
					// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

					//saving default tax value for draft
					this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.newTaxCategoryId;
					this.$parent.Form.productDataModel.defaultTaxValue = productData.newTaxValue;
					this.$parent.Form.productDataModel.defaultCessValue = productData.newCessValue;

					this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable || productData.newCessValue || productData.newCessValueOnQuantity ? true : false;
					this.$parent.fn_checkTaxCategory();
				}
				else{
					this.$parent.Form.productDataModel.taxCategoryId = productData.taxCategoryId;
					this.$parent.Form.productDataModel.taxCategoryName = productData.taxCategoryName;
					this.$parent.Form.productDataModel.taxValue = productData.taxValue;
					this.$parent.Form.productDataModel.cessValue = productData.cessValue;
					this.$parent.Form.productDataModel.cessValueOnQuantity = productData.cessValueOnQuantity ? productData.cessValueOnQuantity : null;
					// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

					//saving default tax value for draft
					this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.taxCategoryId;
					this.$parent.Form.productDataModel.defaultTaxValue = productData.taxValue;
					this.$parent.Form.productDataModel.defaultCessValue = productData.cessValue;

					this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable || productData.cessValue || productData.cessValueOnQuantity ? true : false;
				}
				
			// }

			if(productData.groupTypeId==101){
				this.fn_getBatches(productData.productId);
			}

			if(productData.accountId){
				this.$parent.Form.productDataModel.serviceAccountItemId = productData.accountId;
			}

			// binding custom item fields if any
			if(self.$parent.Form.dynamicItemSection && self.$parent.Form.dynamicItemSection.length){
				self.$parent.fn_bindDynamicItemFields(self.$parent.Form.dynamicItemSection[0].sectionId);
			}

			// this.$parent.Form.productDataModel.taxCategoryId = productData.taxCategoryId;
			// this.$parent.Form.productDataModel.taxCategoryName = productData.taxCategoryName;
			// this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.taxCategoryId;
			// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

			// //saving default tax value for draft
			// this.$parent.Form.productDataModel.defaultTaxValue = productData.taxValue;
			// this.$parent.Form.productDataModel.defaultCessValue = productData.cessValue;
		},
		fn_getBatches: function(productId, addedBatches){
            let self = this;
            this.getData('GetProductBatchByProductId', productId, 
                {
                    onSuccess: function(response){
                        console.log(response);
						self.$set(self.$parent.Form, 'batches', JSON.parse(response));

						if(addedBatches && addedBatches.length){
							for(let i=0; i<addedBatches.length; i++){
								let bIndex = self.$parent.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
								if(bIndex == -1){
									self.$parent.Form.batches.push(addedBatches[i]);
								}
							}
						}
						// if(self.$parent.Form.productData.batches && self.$parent.Form.productData.batches.length){
						// 	self.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
						// }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },
		fn_openDialogSelectBatch: function(){
			// if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
			for(let i=0; i<this.$parent.Form.batches.length; i++){
				this.$parent.Form.batches[i].productQty = null;
				this.$set(this.$parent.Form.batches[i], 'selected', false);
				if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
					for(let j=0; j<this.$parent.Form.productDataModel.batches.length; j++){
						if(this.$parent.Form.productDataModel.batches[j].batchId == this.$parent.Form.batches[i].batchId){
							if(this.$parent.Form.productDataModel.batches[j].productQty){
								this.$parent.Form.batches[i].selected = true;
								this.$parent.Form.batches[i].productQty = this.$parent.Form.productDataModel.batches[j].productQty;
								this.$parent.Form.productDataModel.batches[j].billQty ? this.$parent.Form.batches[i].billQty = this.$parent.Form.productDataModel.batches[j].billQty : '';

								this.$parent.Form.productDataModel.batches[j].isAdded != undefined ? this.$parent.Form.batches[i].isAdded = this.$parent.Form.productDataModel.batches[j].isAdded : '';
								this.$parent.Form.productDataModel.batches[j].qty != undefined ? this.$parent.Form.batches[i].qty = this.$parent.Form.productDataModel.batches[j].qty : '';
								this.$parent.Form.productDataModel.batches[j].refTId != undefined ? this.$parent.Form.batches[i].refTId = this.$parent.Form.productDataModel.batches[j].refTId : '';
								this.$parent.Form.productDataModel.batches[j].refTpBatchId != undefined ? this.$parent.Form.batches[i].refTpBatchId = this.$parent.Form.productDataModel.batches[j].refTpBatchId : '';
								// this.$parent.Form.productDataModel.batches[j].transactionProductBatchId != undefined ? this.$parent.Form.batches[i].transactionProductBatchId = this.$parent.Form.productDataModel.batches[j].transactionProductBatchId : '';
								if(this.$parent.Form.productDataModel.batches[j].refTransactionProductBatchId){
									this.$parent.Form.batches[i].transactionProductBatchId = this.$parent.Form.productDataModel.batches[j].refTransactionProductBatchId;
								}
								else{
									this.$parent.Form.productDataModel.batches[j].transactionProductBatchId != undefined ? this.$parent.Form.batches[i].transactionProductBatchId = this.$parent.Form.productDataModel.batches[j].transactionProductBatchId : '';
								}
								
								this.$parent.Form.productDataModel.batches[j].transactionProductId != undefined ? this.$parent.Form.batches[i].transactionProductId = this.$parent.Form.productDataModel.batches[j].transactionProductId : '';
							}
							// else{
							// 	this.$parent.Form.batches[i].productQty = null;   
							// }
						}
					}
				}
			}
			// }
			this.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
		},
		fn_showHideBatches: function(field){
			if(this.$parent.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4){
				return true;
			}
			else if(this.$parent.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
				return true;
			}
			else{
				return false;
			}
		},
		fn_newBatch: function(){
            this.$parent.backButtonPress = false;
			this.$router.push({path:"/product/batches", query:{pid:this.$parent.Form.productDataModel.productId, dialog:1, new:1}});
        },
		fn_changeProductQty: function(item){
			if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length && this.$parent.Form.productDataModel.batches.length == 1){
				this.$parent.Form.productDataModel.batches[0].productQty = item.qty;
			}
			this.$root.fn_boundDecimalLength(item, this.fn_checkInput, 'qty');
		},
		fn_changeBatchQty: function(batch){
			if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
				let totalVal = 0;
				for(let i=0; i<this.$parent.Form.productDataModel.batches.length; i++){
					totalVal += this.$parent.Form.productDataModel.batches[i].productQty;
				}
				// this.$parent.Form.productDataModel.productVariants[0].qty = Number(totalVal);
				this.$set(this.$parent.Form.productDataModel.productVariants[0], 'qty', Number(totalVal));
			}

			if(batch.billQty != undefined && batch.productQty > batch.billQty){
				this.showToast("Batch quantity should be less then or equal to bill quantity");
			}
		},
		fn_getLabel: function (item) {
			return item.unitName;
			// if(!item.packQuantity){
			// 	return item.unitName;
			// }
			// else{
			// 	return item.unitName+'('+item.packQuantity+')';
			// }
		},
		fn_getSummary: function (itemId) {
			var self = this;
			this.getData('ProductSummary', itemId, 
				{
					onSuccess: function(response){
						console.log(response);
						self.summaryArray = JSON.parse(response);
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_getSummaryGodownWise: function (itemId) {
			var self = this;
			let filterObj = {};
			filterObj.godownId = this.$parent.Form.godownId;
			filterObj.productId = itemId;
			this.getFilterData('ProductSummary', null, filterObj, 
				{
					onSuccess: function(response){
						console.log(response);
						self.summaryArray = JSON.parse(response);
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_getAddOnsLabel: function (item) {
			let label = item.name;
			item.mode == 0 ? label = label+'(%)' : '';
			return label;
		},
		// fn_getBottomMenu: function (tagId) {
		// 	this.$parent.Form.level = "product"
		// 	var bottomMenu = {"BottomMenu": [menuItem.addDiscount, menuItem.addTaxes, menuItem.addOtherCharges]};

		// 	this.setBottomMenu(tagId, bottomMenu, 
		// 		{
		// 			onSuccess: function (response) {
		// 				console.log(response);
		// 			},
		// 			onError: function (error) {
		// 				console.log(error);
		// 			}
		// 		}
		// 	)
		// },
		fn_checkFields: function(doneAndNew){
			if(this.$refs['ref_componentDynamicFields']){
				this.$refs['ref_componentDynamicFields'].$validator.validateAll('fields').then((result) => {
					if(result){
						this.fn_checkValidations(doneAndNew);
					}
				})
			}
			else{
				this.fn_checkValidations(doneAndNew);
			}
		},
		fn_checkValidations: function(doneAndNew){
			this.disableBtn = true;
			let quantityFilled = false;

			// if(this.$parent.fn_isNewTaxForm()){
			// 	let taxPer = this.$parent.Form.productDataModel.taxValue;
			// 	if(taxPer != 5 && taxPer != 12 && taxPer != 40){
			// 		this.$parent.snackbarTaxRate = true;
			// 	}
			// }
			
			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
		        	this.$parent.Form.productDataModel.netAmount = this.netAmount;
		        	let quantityFilled = false;

		        	for(let i=0; i<this.$parent.Form.productDataModel.productVariants.length; i++){
		        		// if(this.$parent.Form.productDataModel.productVariants[i].qty){
		        		// 	quantityFilled = true;
		        		// 	break;
		        		// }
		        		if(!this.$parent.Form.productDataModel.productVariants[i].qty){
		        			this.$parent.Form.productDataModel.productVariants[i].qty = '1';
		        		}
		        	}

					// if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
					// 	let totalBatchQty = 0;
					// 	let bat = null;
					// 	if(this.$parent.Form.selectedBatchType == 2){
					// 		bat = this.$parent.Form.productDataModel.batches.filter(field=>{
					// 			return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4
					// 		})

					// 		this.$parent.Form.productDataModel.batches = this.$parent.Form.productDataModel.batches.filter(field=>{
					// 			return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4
					// 		})
					// 	}
					// 	else{
					// 		bat = this.$parent.Form.productDataModel.batches.filter(field=>{
					// 			return !field.field1 && !field.field2 && !field.field3
					// 		})

					// 		this.$parent.Form.productDataModel.batches = this.$parent.Form.productDataModel.batches.filter(field=>{
					// 			return !field.field1 && !field.field2 && !field.field3
					// 		})
					// 	}
					// 	for(let i=0;i<bat.length;i++){
					// 		totalBatchQty += Number(bat[i].productQty);
					// 	}
					// 	if(this.$parent.Form.productDataModel.productVariants[0].qty != totalBatchQty){
					// 		this.showToast("Product quantity not matched with batch quantity");
					// 		this.disableBtn = false;
					// 		return;
					// 	}
					// }

		        	// if(!quantityFilled){
		        	// 	this.showToast("Please add quantity");
		        	// 	this.disableBtn = false;
		        	// }
					// validating if batch total qty is greater than item qty added in bill
					if(this.$parent.Form.productDataModel.baseTransactionListId != this.$parent.Form.transactionData.transactionListId){
						if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
							let batchTotal = 0;
							let billTotal = 0;
							for(let i=0; i<this.$parent.Form.productDataModel.batches.length; i++){
								batchTotal = batchTotal + Number(this.$parent.Form.productDataModel.batches[i].productQty);
								billTotal = billTotal + Number(this.$parent.Form.productDataModel.batches[i].billQty);
							}
							if(billTotal < batchTotal){
								this.showToast("Batch quantity should be less then or equal to bill quantity");
								this.disableBtn = false;
								return
							}
						}
						else{
							if(!this.fn_checkInput(this.$parent.Form.productDataModel.productVariants[0], true)){
								// this.showToast("Quantity should be less then or equal to bill quantity");
								this.disableBtn = false;
								return
							}
							// if(this.$parent.Form.productDataModel.productVariants[0].qty > this.$parent.Form.productDataModel.productVariants[0].billQty){
							// 	this.showToast("Quantity should be less then or equal to bill quantity");
							// 	this.disableBtn = false;
							// 	return
							// }
						}							
					}

		        	if(this.netAmount<0){
		        		this.showToast("Amount cannot be negative");
		        		this.disableBtn = false;
		        	}
		        	else{
		        		this.saveItem(this.$parent.Form.productDataModel, doneAndNew);
		        	}
		        }
		        else{
		        	this.disableBtn = false;
		        }
		    });
		},
		fn_checkPercentage: function (item) {
			!item.percentage ? item.value = null : '';
		},
		fn_computeValues: function (productData) {
			let grossAmount = 0;
			let grossAmountAsPerMRP = 0;

			let netValue = 0;
			// let finalAmount = 0;

			let self = this;

			//Calculating gross amount
			productData.productVariants.forEach(function (item) {
				let packQty = 1;
				let qty = 1;
				let rate = productData.rate;

				// item.packQuantity ? packQty = item.packQuantity : '';

				item.qty ? qty = item.qty : '';

				//calculation as per rate
				if(!qty || !rate)
					grossAmount += 0;
				else{
					grossAmount += qty * packQty * rate;
				}

				//calculation as per mrp
				let mrp = productData.mrp;
				if(!qty || !mrp)
					grossAmountAsPerMRP += 0;
				else{
					grossAmountAsPerMRP += qty * packQty * mrp;
				}
			})

			productData.grossAmount = this.roundUpto2Decimals(grossAmount);
			productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);

			grossAmount = this.roundUpto2Decimals(grossAmount);
			grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);
			netValue = this.roundUpto2Decimals(grossAmount);

			//calculating addons
			let mrp = productData.mrp ? productData.mrp : 0;
			let addOnsTotalValue = 0;

			// let itemTaxAmount = 0;
			// let addibleTax = 0;

			productData.addOnsItems.forEach(function (item) {

				let applicableAmount = 0;
				let addOnsValue = 0;

				//on net value
				if(item.appliedOn == 0){
					applicableAmount = netValue;
				}//value of goods
				else if(item.appliedOn == 1){
					applicableAmount = grossAmount;
				}//on mrp
				else{
					applicableAmount = grossAmountAsPerMRP;
				}

				//Caculating addOns except gst's
				if(!item.isGst){
					//of value or percentage
					if(item.mode){//value
						addOnsValue = item.value;
					}
					else{//percentage
						if(item.percentage){
							addOnsValue = (applicableAmount*item.percentage)/100;
							item.value = self.roundUpto2Decimals(addOnsValue);
						}
						else if(item.value){
							addOnsValue = item.value;
						}
					}
				}
				

				addOnsValue = self.roundUpto2Decimals(addOnsValue);

				//Final calculation
				if(item.adjustInTotal){
					if(item.nature==0){
						netValue = netValue + addOnsValue;
					}
					else{
						netValue = netValue - addOnsValue;
					}
				}

			});


			//Tax will only affect net amount in case of exclusive tax where this.$parent.Form.taxMode == 1

			let itemTaxAmount = 0;
			let addibleTax = 0;
			let itemCessAmount = 0;

			let itemCessAmountOnQty = 0;
			if(this.$parent.Form.taxMode){

				let taxTotalPercent = productData.taxValue;
				if(productData.isCessApplicable){
					taxTotalPercent = taxTotalPercent + productData.cessValue;
				}

				let taxAmountInclusive = null;

				if(productData.taxValue && self.$parent.Form.taxMode==2){

					let itemNetValue = netValue;

					if(productData.isCessApplicable && productData.cessValueOnQuantity){
						let qtyCessAmount = productData.productVariants[0].qty * productData.cessValueOnQuantity;
						itemNetValue  = itemNetValue - qtyCessAmount;
						itemNetValue < 0 ? itemNetValue = 0 : '';
					}

					let taxPer = productData.taxValue / self.$parent.Form.gstAddOns.length;
					taxAmountInclusive = (itemNetValue * taxPer)/(100+taxTotalPercent);
					// taxAmountInclusive = (netValue * productData.taxValue)/(100+productData.taxValue);
				}
				

				this.$parent.Form.gstAddOns.forEach(function (item) {

					if(productData.taxValue){
						let gstCategoriesLength = self.$parent.Form.gstAddOns.length;

						let percentage = productData.taxValue / gstCategoriesLength;

						item.percentage = percentage;

						//exclusive tax
						if(self.$parent.Form.taxMode==1){
							let taxAmount = (netValue * item.percentage)/100;
							item.value = self.roundUpto2Decimals(taxAmount);
							addibleTax += item.value ? item.value : 0;
							itemTaxAmount += item.value;
						}
						//inclusive tax
						else if(self.$parent.Form.taxMode==2){
							// let taxAmount = (netValue * item.percentage)/(100+item.percentage);
							// item.value = self.roundUpto2Decimals(taxAmountInclusive/gstCategoriesLength);
							item.value = self.roundUpto2Decimals(taxAmountInclusive);
							itemTaxAmount += item.value;
						}
					}

				});

				//Calculation of cess

				if(productData.isCessApplicable){

					this.$parent.Form.cessAddOns.percentage = productData.cessValue;

					//exclusive tax
					if(self.$parent.Form.taxMode==1){
						// let cessAmount = (netValue * this.$parent.Form.cessAddOns.percentage)/100;
						// this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
						// addibleTax += this.$parent.Form.cessAddOns.value;
						if(productData.cessValue != undefined){
							if(productData.cessValue!=null){
								let cessAmount = (netValue * this.$parent.Form.cessAddOns.percentage)/100;
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
								addibleTax += this.$parent.Form.cessAddOns.value ? this.$parent.Form.cessAddOns.value : 0;	
								itemCessAmount = this.$parent.Form.cessAddOns.value;
							}
							else{
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
								addibleTax += productData.cessAmount ? productData.cessAmount : 0;	
								itemCessAmount = productData.cessAmount;
							}
						}
						

						if(productData.cessValueOnQuantity!=undefined){
							if(productData.cessValueOnQuantity!=null){
								let cessAmountOnQty = productData.productVariants[0].qty * productData.cessValueOnQuantity;
								this.$parent.Form.cessAddOns.valueOnQty = self.roundUpto2Decimals(cessAmountOnQty);
								addibleTax += this.$parent.Form.cessAddOns.valueOnQty ? this.$parent.Form.cessAddOns.valueOnQty : 0;	
								itemCessAmountOnQty = this.$parent.Form.cessAddOns.valueOnQty;
							}
						}
						
					}
					//inclusive tax
					else if(self.$parent.Form.taxMode==2){

						if(productData.cessValue != undefined){
							if(productData.cessValue!=null){
																
								let itemNetValue = netValue;
								if(productData.isCessApplicable && productData.cessValueOnQuantity){
									let qtyCessAmount = productData.productVariants[0].qty * productData.cessValueOnQuantity;
									itemNetValue  = itemNetValue - qtyCessAmount;
									itemNetValue < 0 ? itemNetValue = 0 : '';
								}
								
								let cessAmountInclusive = (itemNetValue * productData.cessValue)/(100+taxTotalPercent);
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmountInclusive);
								itemCessAmount = this.$parent.Form.cessAddOns.value;
							}
							else{
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
								itemCessAmount = productData.cessAmount;
							}	
						}

						if(productData.cessValueOnQuantity != undefined){
							if(productData.cessValueOnQuantity!=null){
								let cessAmountOnQtyInclusive = productData.productVariants[0].qty * productData.cessValueOnQuantity;
								this.$parent.Form.cessAddOns.valueOnQty = self.roundUpto2Decimals(cessAmountOnQtyInclusive);
								itemCessAmountOnQty = this.$parent.Form.cessAddOns.valueOnQty;
							}
						}

					}

				}
			}

			productData.taxAmount = self.roundUpto2Decimals(itemTaxAmount);
			productData.cessAmount = self.roundUpto2Decimals(itemCessAmount);
			productData.cessAmountOnQty = self.roundUpto2Decimals(itemCessAmountOnQty);

			if(productData.cessValue==null && itemCessAmount===''){
				productData.cessAmount = null;
			}

			if(productData.itemCessAmountOnQty==null && itemCessAmountOnQty===''){
				productData.itemCessAmountOnQty = null;
			}

			//Taxable amount is net value after deduction of addons on which tax(gst) will apply
			//taxable value in case of exclusive tax

			productData.taxableValue = this.roundUpto2Decimals(netValue);
			// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
			// 	productData.taxableValue = this.roundUpto2Decimals(netValue);
			// }
			// else{
			// 	productData.taxableValue = this.roundUpto2Decimals(netValue + addibleTax);
			// }
			

			//Gross amount in case of inclusive tax
			if(self.$parent.Form.taxMode==2){
				productData.grossAmount = this.roundUpto2Decimals(grossAmount - itemTaxAmount - itemCessAmount - itemCessAmountOnQty);
				productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP - itemTaxAmount - itemCessAmount - itemCessAmountOnQty);
				//taxable value in case of inclusive tax
				productData.taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount - itemCessAmountOnQty);	
				// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
				// 	productData.taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount);	
				// }
				// else{
				// 	productData.taxableValue = this.roundUpto2Decimals(netValue);
				// }
				
			}

			//calculating net amount after default tax
			if(this.$parent.Form.isRcmApplicable){
				return this.roundUpto2Decimals(netValue);				
			}
			else{
				return this.roundUpto2Decimals(netValue + addibleTax);
			}
			// netValue = netValue + addibleTax;

			// return this.roundUpto2Decimals(netValue);
		},
		fn_removeBatch: function(batchIndex){
			this.$parent.Form.productDataModel.batches.splice(batchIndex, 1);
			let totalQty = 0;
			for(let i=0; i<this.$parent.Form.productDataModel.batches.length; i++){
				totalQty = totalQty + Number(this.$parent.Form.productDataModel.batches[i].productQty);
			}
			this.$parent.Form.productDataModel.productVariants[0].qty = totalQty ? totalQty : null;
		},

		fn_unitChange: function(value, item){
			if(!this.dialogJustOpen){
				this.$set(item, 'itemId', value.itemId);
				this.$set(item, 'itemName', value.itemName);
				let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
				if(currentItemId != value.itemId){
					if(value.itemId == item.secondaryUnitId){
						this.$parent.Form.productDataModel.rate = (this.$parent.Form.productDataModel.rate * item.packQuantity) / item.secondaryUnitPackQuantity;
						// this.$parent.Form.productDataModel.rate = this.roundUpto2Decimals(this.$parent.Form.productDataModel.rate / item.secondaryUnitPackQuantity);
					}
					else{
						this.$parent.Form.productDataModel.rate = (this.$parent.Form.productDataModel.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
						// this.$parent.Form.productDataModel.rate = this.roundUpto2Decimals(this.$parent.Form.productDataModel.rate * item.secondaryUnitPackQuantity);
					}	
					// this.tempRate = this.$parent.Form.productDataModel.rate;
					this.$parent.Form.productDataModel.rate = this.roundUpto2Decimals(this.$parent.Form.productDataModel.rate); 
				
					if(item.billQty != undefined){
						this.fn_checkAndUpdateBillQty(value, item);
					}
				}

				this.fn_checkInput(item);
			}
		},

		fn_checkAndUpdateBillQty: function(value, item){
			if(item.secondaryUnitId){
				if(value.itemId == item.secondaryUnitId){
					item.billQty = Math.round(this.roundUpto2Decimals((item.billQty * item.secondaryUnitPackQuantity) / item.packQuantity));
					if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
						for(let i=0; i<this.$parent.Form.productDataModel.batches.length; i++){
							if(this.$parent.Form.productDataModel.batches[i].billQty!=undefined){
								this.$parent.Form.productDataModel.batches[i].billQty = Math.round(this.roundUpto2Decimals((this.$parent.Form.productDataModel.batches[i].billQty * item.secondaryUnitPackQuantity) / item.packQuantity));
							}
						}
					}
				}
				else{
					item.billQty = this.roundUpto2Decimals((item.billQty * item.packQuantity) / item.secondaryUnitPackQuantity);
					if(this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
						for(let i=0; i<this.$parent.Form.productDataModel.batches.length; i++){
							if(this.$parent.Form.productDataModel.batches[i].billQty!=undefined){
								this.$parent.Form.productDataModel.batches[i].billQty = this.roundUpto2Decimals((this.$parent.Form.productDataModel.batches[i].billQty * item.packQuantity) / item.secondaryUnitPackQuantity);
							}
						}
					}
				}
			}
		},

		fn_changeBatchType: function(val){
			if(val==2 && this.$parent.Form.productDataModel.batches && this.$parent.Form.productDataModel.batches.length){
				if(this.$parent.Form.productDataModel.productVariants[0].selectedUnit){
					this.$parent.Form.productDataModel.productVariants[0].selectedUnit = {"itemId":this.$parent.Form.productDataModel.productVariants[0].primaryUnitId, "itemName":this.$parent.Form.productDataModel.productVariants[0].primaryUnitName}
				}
			}
		}

		// fn_assignTempValue: function(val){
		// 	this.tempRate = val;
		// }
	},
	computed:{
		netAmount: function () {
			return this.fn_computeValues(this.$parent.Form.productDataModel);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/purchase/dialogs/dialog_product.vue